import { useCallback, useState } from 'react'
import { Users, Armchair, MessageCircleQuestion } from 'lucide-react'
import AdminScreenShell, { Tegel, StatusRij } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

const fmtAgo = (iso) => {
  if (!iso) return '—'
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000)
  if (s < 60) return `${s}s`
  if (s < 3600) return `${Math.round(s/60)}m`
  return `${Math.round(s/3600)}u`
}

export default function AdminDeelnemersScreen() {
  const [d, setD] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermDeelnemers(); setD(r.data)
  }, [])
  const seats = d?.seats ?? { totaal:0, bezet:0, vrij:0 }
  const helpdesk = d?.helpdesk ?? { open:0, in_progress:0, opgelost_24u:0 }
  const teams = d?.teams ?? []
  const recent = d?.users?.recent ?? []
  const bezetPct = seats.totaal ? Math.round(100 * seats.bezet / seats.totaal) : 0

  return (
    <AdminScreenShell title="Deelnemers" subtitle="Online · seats · teams · helpdesk"
                      icon={Users} refreshMs={15_000} onRefresh={load}>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <Tegel label="Online (5m)"  waarde={d?.users?.online ?? 0}
               sub={`${d?.users?.totaal ?? 0} totaal`} kleur="#61E294" groot />
        <Tegel label="Seats bezet"  waarde={`${seats.bezet}/${seats.totaal}`}
               sub={`${bezetPct}%`} kleur={bezetPct > 80 ? '#FFB57A' : '#B4FF39'} />
        <Tegel label="Helpdesk open" waarde={helpdesk.open}
               sub={`${helpdesk.in_progress} in behandeling`}
               kleur={helpdesk.open > 0 ? '#FFB57A' : '#61E294'} />
        <Tegel label="Teams" waarde={teams.length} kleur="#B4FF39" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            Laatste logins
          </h2>
          {recent.length === 0 ? (
            <div className="text-muted-foreground text-sm">Nog niemand actief in het laatste uur.</div>
          ) : recent.map(u => (
            <StatusRij key={u.username} naam={u.username} sub={`${fmtAgo(u.last_seen_at)} geleden`}
                       status="online" kleur="#61E294" />
          ))}
        </div>

        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            Teams
          </h2>
          {teams.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen teams aangemaakt.</div>
          ) : teams.map(t => (
            <StatusRij key={t.id}
              naam={`[${t.tag ?? '—'}] ${t.name}`}
              sub={`${t.online}/${t.leden} online`}
              status={`${t.online}/${t.leden}`}
              kleur={t.online === t.leden && t.leden > 0 ? '#61E294'
                    : t.online > 0 ? '#FFB57A' : '#FF5A5A'} />
          ))}
        </div>
      </div>
    </AdminScreenShell>
  )
}
